// extracted by mini-css-extract-plugin
export var button = "decision-tree-module--button--46a2e";
export var container = "decision-tree-module--container--0ed7b";
export var content = "decision-tree-module--content--8d04f";
export var decision = "decision-tree-module--decision--e2a5b";
export var entry = "decision-tree-module--entry--14a5b";
export var heading = "decision-tree-module--heading--ad68e";
export var options = "decision-tree-module--options--8d116";
export var priorDecisions = "decision-tree-module--priorDecisions--2509e";